/* 
 * 聊天室SDK，依赖于nim sdk
 */
let SDK = require('@/assets/js/plugins/nim-sdk/' + config.sdk)

import config from '@/config/nimConfig'
import store from '@/store'
import { onChatroomMsgs } from './chatroomMsgs'
import { get_tUser } from '@/assets/js/utils'
// 所有接口
import Actions from '@/api/api-list';

// 切换聊天室之前需要断开连接，原因是移动端不断累积连接实例，消息并发较大时会有性能问题
// 初始化 NIM SDK
export function initChatroomSDK (modelStore, obj) {
  let { rootState, state, commit, dispatch } = modelStore
  if(!SDK){
    return
  }
  // 清空

  let {chatroomId, address} = obj
  let c_t = get_tUser().c_t;
  let sdkTokenObj = localStorage.getItem('sdkTokenObj');
  sdkTokenObj = sdkTokenObj ? JSON.parse(sdkTokenObj) : {};
  
  if (chatroomId && address) {
    if (state.chatroomInsts[chatroomId]) {
      console.log('已经存在了',state.chatroomInsts[chatroomId])
      state.chatroomInsts[chatroomId].connect()
    } else {
      let currChatroom = SDK.Chatroom.getInstance({
        appKey: config.appkey,
        account: c_t, // cv account token 或者 hr account token
        token: sdkTokenObj[c_t], // 根据后端接口，拿到网易token
        transports: ['websocket'],
        chatroomId,
        chatroomAddresses: [address[0]], // 聊天室地址
        onconnect: (chatroom) => {
          console.log('initChatroomSDK=>>>','onconnect')
          // dispatch('hideLoading')
          // console.log('Chatroom onconnect',)
          commit('setCurrChatroom', chatroomId)
          // 提交链接状态
          commit('updateNimState', { state: 'chatroomConnectionState', value: true})
          // 网络没问题
          // commit('updateChatroomNetworkAnomaly', false)

          // 获取聊天室信息
          dispatch('getChatroomInfo',{ getMember: true })
          // 获取我的信息
          dispatch('getCurrMyChatroomInfo',{ chatroomId, account: c_t})
        },
        onerror: (error, obj) => {
          console.log('Chatroom onerror', obj)
          // 网络问题
          commit('updateChatroomNetworkAnomaly', true)
          // dispatch('hideLoading')
          // if (error) {
          //   alert('网络连接状态异常')
          //   location.href='#/room'
          // }
        },
        onwillreconnect: (obj) => {
          // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
          console.log('即将重连', obj)
          // 网络问题
          commit('updateChatroomNetworkAnomaly', true)
        },
        ondisconnect: (error) => {
          console.log('Chatroom ondisconnect', obj)
          // 此时说明 `SDK` 处于断开状态, 切换聊天室也会触发次回调
          // dispatch('hideLoading')
          if (error) {
            switch (error.code) {
              // 账号或者密码错误, 请跳转到登录页面并提示错误
              case 302:
                // 此逻辑与nim sdk错误逻辑相同，复用nim sdk的
                // 如果单用聊天室功能需要在此做处理
                let c_t = get_tUser().c_t;
                let sdkTokenObj = localStorage.getItem('sdkTokenObj');
                sdkTokenObj = sdkTokenObj ? JSON.parse(sdkTokenObj) : {};
                if(c_t){
                  Actions.im.getNimToken(c_t).then(res=>{
                    if(res.code === 1000){
                      sdkTokenObj[c_t] = res.data.acc_token;
                      localStorage.setItem('sdkTokenObj', JSON.stringify(sdkTokenObj));
                      // 提交sdk连接请求
                      store.dispatch('nim/connect',{
                        ...obj,
                        type: 'chatroom',
                      })
                    }
                  })
                }

                break;
              case 13003:
                // alert('抱歉，你已被主播拉入了黑名单')
                break
                // 被踢, 请提示错误后跳转到登录页面
              case 'kicked':
                // if (error.reason === 'managerKick') {
                //   alert('你已被管理员移出聊天室')
                // } else if (error.reason === 'blacked') {
                //   alert('你已被管理员拉入黑名单，不能再进入')
                // }
                break;
              default:
                console.log(error.message);
                break
            }
          }
        },
        // 聊天室消息
        onmsgs: (msgs)=>{
          onChatroomMsgs(modelStore, msgs)
        } 
      })
      try {
        // state.currChatroom = currChatroom;
      } catch (error) {}
      if(window){
        window.chatroom = currChatroom
      }
      // commit('addChatroomInsts',{chatroomId, currChatroom})
      // state.chatroomInsts[chatroomId] = currChatroom

    }
  } else {
    // alert('没有聊天室地址')
  }
}

export function resetChatroomSDK ({state, commit, dispatch}, chatroomId) {
  if (chatroomId) {
    state.chatroomInsts[chatroomId].disconnect()
  } else {
    for (let tempRoomId in state.chatroomInsts) {
      state.chatroomInsts[tempRoomId].disconnect()
    }
  }
  commit('resetCurrChatroom')
}
